module.exports = __webpack_public_path__ + "static/media/arrowdownward.ecd50f0a.svg";